import classNames from 'classnames';
import React from 'react';

const LivePreview = ({previews, isSmallScreen}: {previews: string[]; isSmallScreen: boolean}) => {
  const classes = classNames(
    'items-center',
    'flex',
    'overflow-auto',
    'w-full',
    'h-full',
    isSmallScreen ? ['flex-col'] : ['flex-row']
  );

  const containerClasses = classNames('shadow-lg', isSmallScreen ? ['mb-lg'] : ['mr-lg']);
  const imgStyle = isSmallScreen ? {} : {maxWidth: 'unset'};
  return (
    <div className={classes}>
      {previews
        ?.map((s: string, index: number) => {
          if (!s) {
            return null;
          }
          return (
            <div className={containerClasses} key={index}>
              <img src={s} alt={`Page ${index}`} className="border object-cover" style={imgStyle} />
            </div>
          );
        })
        .filter(i => i)}
    </div>
  );
};

export default LivePreview;
